import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "addButton"]

  connect() {
    this.updateRemoveButtonsVisibility()
  }

  addField(event) {
    if (event) {
      event.preventDefault()
    }

    const template = this.templateTarget
    const newField = template.content.cloneNode(true)
    const fieldContainer = newField.querySelector('[data-country-field-wrapper]')

    if (!fieldContainer) {
      console.error('Template structure error: data-country-field-wrapper not found')
      return
    }

    const currentCount = this.containerTarget.querySelectorAll('[data-country-field-wrapper]').length
    const index = currentCount

    this.updateFieldIndex(fieldContainer, index)

    this.containerTarget.appendChild(newField)
    this.updateRemoveButtonsVisibility()
  }

  removeField(event) {
    if (event) {
      event.preventDefault()
    }

    const fieldWrapper = event.target.closest('[data-country-field-wrapper]')
    if (!fieldWrapper) return

    if (this.containerTarget.querySelectorAll('[data-country-field-wrapper]').length > 1) {
      fieldWrapper.remove()
      this.updateRemoveButtonsVisibility()
      this.reindexFields()
    }
  }

  updateFieldIndex(fieldContainer, index) {
    const inputs = fieldContainer.querySelectorAll('input, select')
    inputs.forEach(input => {
      if (input.name) {
        input.name = input.name.replace('INDEX_PLACEHOLDER', index)
      }
      if (input.id) {
        input.id = input.id.replace('INDEX_PLACEHOLDER', index)
      }
    })
  }

  reindexFields() {
    const wrappers = this.containerTarget.querySelectorAll('[data-country-field-wrapper]')
    wrappers.forEach((wrapper, index) => {
      const inputs = wrapper.querySelectorAll('input, select')
      inputs.forEach(input => {
        if (input.name) {
          input.name = input.name.replace(/\[\d+\]/, `[${index}]`)
        }
        if (input.id) {
          input.id = input.id.replace(/_\d+_/, `_${index}_`)
        }
      })
    })
  }

  updateRemoveButtonsVisibility() {
    const removeButtons = this.containerTarget.querySelectorAll('button[data-action*="remove"]')
    const fieldCount = this.containerTarget.querySelectorAll('[data-country-field-wrapper]').length

    removeButtons.forEach(button => {
      if (fieldCount <= 1) {
        button.classList.add('hidden')
      } else {
        button.classList.remove('hidden')
      }
    })
  }
}
